import { useMemo } from 'react';
import { useLocation } from 'umi';

export default function useInitialDateRange() {
  const location = useLocation();

  const dateRange = useMemo(() => {
    const urlSearchParams = new URLSearchParams(location.search);
    const startDate = decodeURIComponent(urlSearchParams.get('start_date') || '');
    const endDate = decodeURIComponent(urlSearchParams.get('end_date') || '');
    return {
      startDate,
      endDate,
    };
  }, [location?.search]);

  return dateRange;
}
